import React, { Component } from "react";
import { QuestionTypes } from "../../../../constants/QuestionTypes";

class TypeText extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Text: this.props.Question_Text,
    Question_Type_ID: this.props.Question_Type_ID || null
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async handleSave() {
    let Question_Answers = [{ Answer_ID: 0, Answer_Text: this.state.Question_Text, Deleted: false }]
    const Question_ID = (QuestionTypes.Checkbox === this.state.Question_Type_ID) ? await this.props.onSave(Question_Answers) : await this.props.onSave();
    this.setState({ Question_ID });
  }

  handleRemove() {
    this.props.onRemove();
  }

  render() {
    return (
      <React.Fragment>
        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default TypeText;
